<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Clients
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Clients</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- =============latest videos========== -->
    <section>
        <div class="latest-blog cpy-8">
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-7 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4>Our Loyal Clients</h4>
                                <h2>pillars of our business</h2>
                                <p>
                                    Empowering our clients with textile machinery, ensuring efficiency, quality, and
                                    innovation for a sustainable and successful future.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--row end  -->

                <div class="video-tabing client-list-page mt-5">
                    <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation" *ngFor="let client of clientListArr; let v = index;">
                            <button class="nav-link" [ngClass]="{'active': currentTab == client?.id}" id="home-tab"
                                data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab"
                                aria-controls="home" aria-selected="true"
                                (click)="currentActiveCate(client?.id, v)">{{client?.category}}</button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="tab-content mt-5" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div class="row justify-content-start">
                                <div class="col-lg-3 col-md-4 col-sm-6 mb-5"
                                    *ngFor="let cliImg of currentIndDetail; let vind = index;">
                                    <div class="client-image-sec text-center">
                                        <img class="img-fluid img-thumbnail bg-theme" [src]="cliImg?.image">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <app-video-overlay #videoOverlay></app-video-overlay>

                    <!-- row end  -->
                </div>
                <!-- mt-5 end  -->
            </div>
        </div>
    </section>
    <!-- ========= Updates====latest videos end ========== -->